import * as types from "../actions/actionTypes";
const INITIAL_CONFIRM = {
  show: false,
  type:"",
  title: "",
  message: "",
  onAccept: () => {}
};

const DEFAULT_TEAM = {
  name: ""
};
const DEFAULT_TEAM_LEVEL = {
  name: ""
};
const INITIAL_TEAM_LEVELS_DATA = {
  team: {},
  data: []
};

const initialState = {
  loading: true,
  list: [],
  error: "",
  fetched: false,

  team: DEFAULT_TEAM,
  showLoading: false,
  showError: "",

  lastAddedItem: null,
  processing: false,

  removeProcessing: false,

  levelsData: INITIAL_TEAM_LEVELS_DATA,
  levelsLoading: true,
  levelsError: "",

  reorderProcessing: false,

  level: DEFAULT_TEAM_LEVEL,
  showLevelLoading: false,
  showLevelError: "",

  levelProcessing: false,
  removeLevelProcessing: false,
  removeLevelApproverProcessing: false,

  levelApprovers: [],
  levelApproversLoading: false,
  levelApproversError: "",

  levelApproverProcessing: false,

  confirm: INITIAL_CONFIRM,

  teamModalData: {},
  teamModalStatus: false,

  teamLevelModalData: {},
  teamLevelModalStatus: false,

  widgetsProcessing: false
};

const Team = (state = initialState, action) => {
  let list, levels;
  switch (action.type) {
    case types.GET_TEAMS_LIST_REQUEST:
      return { ...state, loading: true, error: "" };
    case types.GET_TEAMS_LIST_SUCCESS:
      return { ...state, list: action.data, loading: false, fetched: true };
    case types.GET_TEAMS_LIST_FAILURE:
      return { ...state, loading: false, error: action.error };

    case types.SHOW_TEAM_REQUEST:
      return {
        ...state,
        team: DEFAULT_TEAM,
        showLoading: true,
        showError: ""
      };
    case types.SHOW_TEAM_SUCCESS:
      return {
        ...state,
        team: action.payLoad,
        showLoading: false
      };
    case types.SHOW_TEAM_FAILURE:
      return { ...state, showLoading: false, showError: action.error };

    case types.UPDATE_TEAM_REQUEST:
      return { ...state, processing: true };
    case types.UPDATE_TEAM_SUCCESS:
      list = [];
      if (state.list.length) {
        list = state.list.map(item => {
          if (item.id === Number(action.payLoad.id)) {
            return { ...action.payLoad };
          } else {
            return item;
          }
        });
      }
      return {
        ...state,
        team: action.payLoad,
        processing: false,
        list: list,
        teamModalData: {},
        teamModalStatus: false
      };
    case types.UPDATE_TEAM_FAILURE:
      return { ...state, processing: false };

    case types.SET_TEAM_MODAL_DATA:
      return { ...state, teamModalData: action.data, teamModalStatus: true };
    case types.CLOSE_TEAM_MODAL:
      return { ...state, teamModalData: {}, teamModalStatus: false };

    case types.STORE_TEAM_REQUEST:
      return { ...state, processing: true };
    case types.STORE_TEAM_SUCCESS:
      if (action.projectId) {
        list = [...state.list];
        list.push(action.payLoad);
      }
      return {
        ...state,
        lastAddedItem: action.payLoad,
        processing: false,
        list: list,
        teamModalData: {},
        teamModalStatus: false
      };
    case types.STORE_TEAM_FAILURE:
      return { ...state, processing: false };

    case types.REMOVE_TEAM_REQUEST:
      return { ...state, removeProcessing: true };
    case types.REMOVE_TEAM_SUCCESS:
      list = state.list;
      list = list.filter(item => item.id !== parseInt(action.id));
      return {
        ...state,
        list: list,
        removeProcessing: false,
        confirm: INITIAL_CONFIRM
      };
    case types.REMOVE_TEAM_FAILURE:
      return { ...state, removeProcessing: false, confirm: INITIAL_CONFIRM };

    case types.CLEAR_LAST_ADDED_TEAM:
      return { ...state, lastAddedItem: null };

    case types.GET_TEAM_LEVELS_REQUEST:
      return {
        ...state,
        levelsData: INITIAL_TEAM_LEVELS_DATA,
        levelsLoading: true,
        levelsError: ""
      };
    case types.GET_TEAM_LEVELS_SUCCESS:
      return { ...state, levelsData: action.data, levelsLoading: false };
    case types.GET_TEAM_LEVELS_FAILURE:
      return { ...state, levelsLoading: false, levelsError: action.error };

    case types.REORDER_TEAM_LEVELS_REQUEST:
      return {
        ...state,
        reorderProcessing: true
      };
    case types.REORDER_TEAM_LEVELS_SUCCESS:
      return { ...state, reorderProcessing: false };
    case types.REORDER_TEAM_LEVELS_FAILURE:
      return { ...state, reorderProcessing: false };

    case types.SHOW_TEAM_LEVEL_REQUEST:
      return {
        ...state,
        level: DEFAULT_TEAM_LEVEL,
        showLevelLoading: true,
        showLevelError: ""
      };
    case types.SHOW_TEAM_LEVEL_SUCCESS:
      return { ...state, level: action.data, showLevelLoading: false };
    case types.SHOW_TEAM_LEVEL_FAILURE:
      return {
        ...state,
        showLevelLoading: false,
        showLevelError: action.error
      };

    case types.UPDATE_TEAM_LEVEL_REQUEST:
      return { ...state, levelProcessing: true };
    case types.UPDATE_TEAM_LEVEL_SUCCESS:
      const updatedLevelData = action.payLoad;
      levels = [...state.levelsData.data];

      levels = [];
      if (state.levelsData.data.length) {
        levels = state.levelsData.data.map(item => {
          if (item.id === Number(updatedLevelData.id)) {
            return { ...item, ...action.payLoad };
          } else {
            return item;
          }
        });
      }

      return {
        ...state,
        levelProcessing: false,
        levelsData: { ...state.levelsData, data: levels },
        teamLevelModalData: {},
        teamLevelModalStatus: false
      };
    case types.UPDATE_TEAM_LEVEL_FAILURE:
      return { ...state, levelProcessing: false };

    case types.STORE_TEAM_LEVEL_REQUEST:
      return { ...state, levelProcessing: true };
    case types.STORE_TEAM_LEVEL_SUCCESS:
      const addedLevelData = { ...action.payLoad, users: [] }; //todo fix maybe need approver array
      levels = [...state.levelsData.data];
      levels.splice(levels.length - 1, 0, addedLevelData);
      return {
        ...state,
        levelProcessing: false,
        levelsData: { ...state.levelsData, data: levels },
        teamLevelModalData: {},
        teamLevelModalStatus: false
      };
    case types.STORE_TEAM_LEVEL_FAILURE:
      return { ...state, levelProcessing: false };

    case types.REMOVE_TEAM_LEVEL_REQUEST:
      return { ...state, removeLevelProcessing: true };
    case types.REMOVE_TEAM_LEVEL_SUCCESS:
      const removedLevelId = action.payLoad;
      levels = [...state.levelsData.data]; // because deepCopy is needed :)
      levels = levels.filter(item => item.id !== Number(removedLevelId));
      return {
        ...state,
        removeLevelProcessing: false,
        levelsData: { ...state.levelsData, data: levels },
        confirm: INITIAL_CONFIRM
      };
    case types.REMOVE_TEAM_LEVEL_FAILURE:
      return {
        ...state,
        removeLevelProcessing: false,
        confirm: INITIAL_CONFIRM
      };

    case types.SET_TEAM_LEVEL_MODAL_DATA:
      return {
        ...state,
        teamLevelModalData: action.data,
        teamLevelModalStatus: true
      };
    case types.CLOSE_TEAM_LEVEL_MODAL:
      return { ...state, teamLevelModalData: {}, teamLevelModalStatus: false };

    case types.REMOVE_TEAM_LEVEL_APPROVER_REQUEST:
      return { ...state, removeLevelApproverProcessing: true };
    case types.REMOVE_TEAM_LEVEL_APPROVER_SUCCESS:
      return {
        ...state,
        removeLevelApproverProcessing: false,
        confirm: INITIAL_CONFIRM
      };
    case types.REMOVE_TEAM_LEVEL_APPROVER_FAILURE:
      return {
        ...state,
        removeLevelApproverProcessing: false,
        confirm: INITIAL_CONFIRM
      };

    case types.GET_TEAM_LEVEL_APPROVERS_REQUEST:
      return {
        ...state,
        levelApprovers: [],
        levelApproversLoading: true,
        levelApproversError: ""
      };
    case types.GET_TEAM_LEVEL_APPROVERS_SUCCESS:
      return {
        ...state,
        levelApprovers: action.data,
        levelApproversLoading: false
      };
    case types.GET_TEAM_LEVEL_APPROVERS_FAILURE:
      return {
        ...state,
        levelApproversLoading: false,
        levelApproversError: action.error
      };

    case types.STORE_TEAM_LEVEL_APPROVER_REQUEST:
      return { ...state, levelApproverProcessing: true };
    case types.STORE_TEAM_LEVEL_APPROVER_SUCCESS:
      return {
        ...state,
        levelApproverProcessing: false,
        confirm: INITIAL_CONFIRM
      };
    case types.STORE_TEAM_LEVEL_APPROVER_FAILURE:
      return {
        ...state,
        levelApproverProcessing: false,
        confirm: INITIAL_CONFIRM
      };

    case types.SET_TEAM_SHOW_CONFIRM_DATA:
      return { ...state, confirm: action.data ? action.data : INITIAL_CONFIRM };

    case types.UPDATE_TEAM_WIDGETS_REQUEST:
      return { ...state, widgetsProcessing: true };
    case types.UPDATE_TEAM_WIDGETS_SUCCESS:
      return {
        ...state,
        widgetsProcessing: false
      };
    case types.UPDATE_TEAM_WIDGETS_FAILURE:
      return { ...state, widgetsProcessing: false };
    default:
      return state;
  }
};

export default Team;
